import React from 'react';
import styled from '@emotion/styled';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';
import { BASE } from './theme';

const Line = styled.p`
  margin: 0; display: flex; flex-wrap: wrap; gap: 0.4em 1.2em; align-items: center; color: ${BASE.muted};
  font-size: ${(p) => (p.$wall ? 'clamp(0.9rem, 1.2vw, 1.4rem)' : '0.9rem')};
  a { color: ${BASE.accent}; display: inline-flex; align-items: center; gap: 0.3em; }
`;

/** Where a table's numbers come from: source, licence and a link, under every chart. */
export default function SourceLine({ table, wall = false }) {
  const { t } = useTranslation();
  if (!table) return null;
  return (
    <Line $wall={wall}>
      <span>{t('statisticsView.source', { source: table.source })}</span>
      {table.unit && <span>{t('statisticsView.unit', { unit: table.unit })}</span>}
      {table.licence && <span>{t('statisticsView.licence', { licence: table.licence })}</span>}
      {table.source_url && (
        <a href={table.source_url} target="_blank" rel="noreferrer"><ExternalLink size={wall ? 18 : 14} /> {t('statisticsView.openSource')}</a>
      )}
      {table.note && <span>{table.note}</span>}
    </Line>
  );
}
